export default __webpack_public_path__ + "static/media/wall.782986ce.png";